import React, { memo, useEffect, useState, useRef } from 'react';
import Label from '../utils/label';

function Alert() {
	const [showModal, setShowModal] = useState(false);
	const [text, setText] = useState('');
	
	
	function closeModal() {
		setShowModal(false);
	}
	
	const modalRef = useRef(null);

	// add show alert eventListenter
	useEffect(() => {
		function showAlert(e) {
			const { text } = e.detail;
			setText(text);
			setShowModal(true);
		}
		
		modalRef.current.addEventListener('showAlert', showAlert);
		return () => modalRef.current.removeEventListener('showAlert', showAlert);
	}, []);
	
	// on press enter
	useEffect(() => {
		if (showModal) {
			return;
		}

		function pressEnter(e) {
			e.key === 'Enter' && closeModal();
		}
	
		window.addEventListener('keyup', pressEnter);
		return () => window.removeEventListener('keyup', pressEnter);
	}, [showModal]);
	
	return (
		<div className={`popupPanel-smaller alertMessage-normal ${showModal ? '' : 'hidden'}`}>
			<div className="heading-default" ref={modalRef} id="alert-modal">
				<div className="text icon-messageInfo" title="Alert">Alert</div>
			</div>
			<div className="contentArea">
				<div className="otherContent">
					<div className="text-larger">
						{text}
					</div>
					<div className="btnArea">
						<div className="largeBtn" title={Label.lbl_OK} onClick={closeModal}>{Label.lbl_OK}</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default memo(Alert);